module.exports = __webpack_public_path__ + "assets/img/5icon.244ab85d.png";